<template>
  <div>
    <div class="Tranbox">
      <div class="Tranboxtitle">Trabsactions</div>
      <div class="Tranboxlist">
        <div class="Tranbox_left">
          <Listbox style="width: 486px; height: 131px; background: #13161b">
            <template #headers> Number of Accounts </template>
            <template #leftcon> 25555523 </template>
            <template #lefttit> Total </template>
            <template #rightcon> +233434 </template>
            <template #footers> Last 24h </template>
          </Listbox>
          <listbox style="width: 486px; height: 131px; background: #13161b">
            <template #headers> Daily Active Accounts </template>
            <template #leftcon> 25555523 </template>
            <template #lefttit> Total </template>
            <template #rightcon> +5.55% </template>
            <template #footers> 24h Change </template>
          </listbox>
        </div>
        <div class="Tranbox_right">
          <div class="title">Total Account & Active Account</div>
          <div class="charts">
            <div id="charts" ref="chart" style="height: 250px"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="Blocks">
      <div class="Block_Top notranslate">
        <span class="notranslate">Accounts</span>
        <span>
          <el-pagination
            ref="Pagination"
            :current-page.sync="PaginationIndex"
            background
            layout="prev, pager,
      next"
            @current-change="CurrentChange"
            :total="total1"
            v-show="list.length > 0"
          >
          </el-pagination>
        </span>
      </div>
      <div v-show="list.length > 0">
        <div class="Block_list">
          <ul class="block_list_Top">
            <li>#</li>
            <li>Address</li>
            <li>Balance</li>
            <li>Percentage</li>
            <li>Txn Count</li>
            <li>Latest Txn Time</li>
          </ul>
        </div>
        <div class="Block_List_center notranslate">
          <ul>
            <li v-for="(item, index) in list" :key="index">
              <p>
                <span >{{ item.id }}</span>
              </p>
              <p @click="TxHash(index)">{{ getSubStr(item.txHash) }}</p>
              <p>{{ item.amount }}TTOS</p>
              <p>
                {{ item.consensus }}%
              </p>
              <p>
                {{ item.tradeNums }}
              </p>
              <p>
                {{ item.tradeTime }}
              </p>
            </li>
          </ul>
        </div>
        <div class="Block_List_Bottom">
          <el-pagination
            ref="Pagination"
            :current-page.sync="PaginationIndex"
            background
            layout="prev, pager,
      next"
            @current-change="CurrentChange"
            :total="total1"
          >
          </el-pagination>
        </div>
      </div>
      <div v-show="list.length <= 0">
        <EmptyState />
      </div>
    </div>
  </div>
</template>

<script>
import Listbox from "../../../components/pc/Listbox.vue";
import Pagination from "../BlockList/Pagination";
import Pagination2 from "../BlockList/Pagination2.vue";
import EmptyState from "../EmptyState/EmptyState.vue";
import { TradeList } from "@/assets/server/api";
import { timestampConvertTime, formatSeconds } from "@/utils/utils";
import { TypeTxsList } from "@/assets/server/api.js";
const echarts = require("echarts");
export default {
  props: ["List", "tradeNums"],
  data() {
    return {
      list: [],
      Time: [],
      PaginationIndex: 1,
      total1: null,
      Type: "",
      txHash: [],
      fromAddress: [],
      toAddress: [],
      data: [],
      data2: [],
      data3: [],
      ToList: 0,
      Tiaoshu: "",
      Page1: "",
      TimeDate: [],
      ImgUrl4: require("@/assets/pc/TopValidators/xiala2.png"), //向下下拉箭头
      calendarDatas: [
        {
          name: "ALL",
          value: "",
        },
        {
          name: "Signature Rewards",
          value: 1,
        },
        {
          name: "Transfer",
          value: 2,
        },
        {
          name: "Bonus",
          value: 3,
        },
        {
          name: "Delegate ",
          value: 4,
        },
        {
          name: "Withdraw",
          value: 5,
        },
        {
          name: "Stake",
          value: 1,
        },
        {
          name: "Unstake",
          value: 2,
        },
      ],
      value: "",
    };
  },
  components: {
    Pagination,
    Pagination2,
    EmptyState,
    Listbox,
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  watch: {},
  created() {
    this.PaginationIndex = this.getContextData("tiaozhuan2") || 1;
   // this.TransactionsList();
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    initCharts() {
      this.lineChart = echarts.init(this.$refs.chart);
      let option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {
        //   data: ["Email", "Union Ads", "Video Ads", "Direct", "Search Engine"],
        // },
        grid: {
          top: "9%",
          left: "3%",
          right: "4%",
          bottom: "8%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: true,
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
          axisLine: {
            show: false, //隐藏x轴线
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false, //隐藏x轴刻度
          },
        },
        yAxis: {
          type: "value",
          show: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "#fff",
            },
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#00E79A",
                },
                {
                  offset: 0,
                  color: "#00E79A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#00E79A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
          {
            type: "line",
            smooth: true, //是否平滑
            symbol: "circle",
            smooth: true, // 线条是否平滑
            // symbol: "none", // 是否显示节点
            showSymbol: false,
            //showAllSymbol:true,
            symbolSize: 10,
            lineStyle: {
              color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                {
                  offset: 1,
                  color: "#D3F85A",
                },
                {
                  offset: 0,
                  color: "#D3F85A",
                },
              ]), //线条渐变色
              shadowOffsetX: 1, // 折线的X偏移
              shadowOffsetY: 9, // 折线的Y偏移
              shadowBlur: 8, // 折线模糊
              shadowColor: "rgba(146, 169, 255, 100)", //折线颜色
            },
            itemStyle: {
              color: "#000",
              borderColor: "#D3F85A",
              borderWidth: 2,
              shadowColor: "rgba(0, 0, 0, .3)",
              shadowBlur: 0,
              shadowOffsetY: 2,
              shadowOffsetX: 2,
            },
            data: [82, 92, 91, 34, 190, 130, 120],
          },
        ],
      };
      this.lineChart.setOption(option);
    },
    async getTypeTxsList() {
      let formData = new FormData();
      let params = {
        address: this.$route.query.Address,
        type: this.value,
        pageNum: this.PaginationIndex,
        pageSize: 10,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await TypeTxsList(formData);
     // console.log(res);
    },
    CurrentChange(val) {
      this.PaginationIndex = val;
      // this.setContextData("tiaozhuan2", this.PaginationIndex);
    //  this.TransactionsList();
    },
    TransactionsList() {
      let _this = this;
      const params = {
        pageNum: _this.PaginationIndex,
        pageSize: 10,
      };
      const formData = new FormData();
      const item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      TradeList(formData).then((res) => {

        _this.list = res.result.tradeList;
        //console.log(_this.list);
        this.Tiaoshu = res.result.total;
        this.Tiaoshu = "(" + this.Tiaoshu + ")";
        _this.total1 = res.result.total;
        var calctime = new Date();
        let strdate = Math.floor(calctime.getTime() / 1000);
        for (let i = 0; i < _this.list.length; i++) {
          let UTCTime =
            res.result.tradeList[i].tradeTime -
            this.getClientTimezone * 3600000;
          this.TimeDate[i] = timestampConvertTime(UTCTime);
          let timestamp = Math.floor(
            this.gltime(this.list[i].tradeTime) / 1000
          );
          var s = strdate - timestamp;
          if (s <= 0) {
            s = 1;
          }
          this.list[i].tradeTime = formatSeconds(s);
          this.list[i].toAddress = _this.list[i].toAddress.split(",");

          if (_this.list[i].type == 1) {
            _this.list[i].type = "Transfer";
          } else if (_this.list[i].type == 2) {
            _this.list[i].type = "Stake";
          } else if (_this.list[i].type == 3) {
            _this.list[i].type = "Unstake";
          } else if (_this.list[i].type == 5) {
            _this.list[i].type = "Withdraw";
          } else if (_this.list[i].type == 4) {
            _this.list[i].type = "Delegate";
          } else if (_this.list[i].type == 99) {
            _this.list[i].type = "Bonus";
          } else if (_this.list[i].type == -1) {
            _this.list[i].type = "Genesis";
          }
        }
      });
    },
    gltime(i) {
      const toDate = new Date(i);
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000;
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },

    TxHash(index) {
      let params = {
        txHash: this.list[index].txHash,
      };
      this.$router.push({ path: "/pc/To", query: params });
    },
    getSubStr(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    getSubStr2(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    getSubStr3(str) {
      var subStr1 = str.substr(0, 5);
      var subStr2 = str.substr(str.length - 5, 5);
      var subStr = subStr1 + "..." + subStr2;
      return subStr;
    },
    Address(index) {
      let params = this.list[index].fromAddress;
      this.$router.push({ path: "/pc/BkHash", query: { query: params } });
    },
    Address2(index) {
      let params = this.list[index].toAddress[0];
      this.$router.push({ path: "/pc/BkHash", query: { query: params } });
    },
    tiaozhuan1(e) {
      this.PaginationIndex = e;
      this.TransactionsList();
    },
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
  },
};
</script>

<style lang="less" scoped>
.Tranbox {
  width: 1160px;
  height: 398px;
  background: #000000;
  border-radius: 20px 20px 20px 20px;
  opacity: 1;
  margin-bottom: 20px;
  .Tranboxtitle {
    margin-left: 20px;
    padding-top: 30px;
    font-size: 18px;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #ffffff;
  }
  .Tranboxlist {
    display: flex;
    justify-content: space-between;
    .Tranbox_left {
      margin-top: 30px;
      margin-left: 20px;
      .Tranbox_box {
        width: 486px;
        height: 131px;
        background: #13161b;
        border-radius: 12px 12px 12px 12px;
        opacity: 1;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        .Tranbox_boxl {
          margin-top: 20px;
          margin-left: 20px;
          .Tranbox_title {
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            height: 17px;
            line-height: 17px;
          }
          .Tranbox_num {
            font-size: 24px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #00e79a;
            margin-top: 8px;
            height: 35px;
            line-height: 35px;
            margin-bottom: 14px;
          }
          .Tranbox_tt {
            height: 17px;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            line-height: 17px;
          }
        }
        .Tranbox_boxr {
          margin-right: 20px;
          margin-top: 45px;
          .Tranbox_rnum {
            height: 35px;
            font-size: 24px;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #00e79a;
            line-height: 35px;
            margin-bottom: 14px;
          }
          .Tranbox_time {
            height: 17px;
            font-size: 12px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.5);
            line-height: 17px;
            text-align: right;
          }
        }
      }
    }
    .Tranbox_right {
      width: 614px;
      height: 282px;
      background: #13161b;
      border-radius: 12px 12px 12px 12px;
      opacity: 1;
      margin-right: 20px;
      margin-top: 30px;
      .title {
        margin-left: 20px;
        margin-top: 20px;
        height: 17px;
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.5);
        line-height: 17px;
      }
    }
  }
}
.Blocks {
  padding: 20px 0px;
  background: #000000;
  width: 1160px;

  border-radius: 16px 16px 16px 16px;
  .Block_Top {
    margin: 0 auto;
    width: 1120px;
    margin-bottom: 24px;
    display: flex;
    span {
      flex: 1;
    }
    span:nth-child(1) {
      font-size: 16px;
      font-family: SF Pro Text-Medium, SF Pro Text;
      font-weight: 500;
      color: rgba(255, 255, 255, 0.9);
      line-height: 24px;
      -webkit-background-clip: text;
      b {
        margin-left: 4px;
        color: rgba(255, 255, 255, 0.55);
      }
    }
  }
  .Block_list {
    width: 1120px;
    margin: 0 auto;
    .block_list_Top {
      display: flex;

      height: 60px;
      background: #14151a;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      li {
        font-size: 16px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898b8d;
        height: 60px;
        line-height: 60px;
        -webkit-background-clip: text;
        flex: 0 0 15%;
        text-align: left;
        margin-left: 20px;
      }
      li:nth-child(3) {
        flex: 0 0 16%;
      }
    }
  }
  .Block_List_center {
    width: 1120px;
    margin: 0 auto;
    ul {
      height: 620px;
      // padding: 0 19px;
      li {
        display: flex;
        height: 62px;
        border-bottom: 1px solid #22252e;
        line-height: 62px;
        p {
          font-size: 14px;
          font-family: SF Pro Text-Regular, SF Pro Text;
          font-weight: 400;
          -webkit-background-clip: text;
          flex: 0 0 15%;
          text-align: left;
          margin-left: 20px;
          span {
            display: inline-block;
            width: 150px;
          }
        }
      }
      // li:nth-child(10) {
      //   border-bottom: none !important;
      // }
      p:nth-child(1) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898B8D;

        cursor: pointer;
      }
      p:nth-child(2) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
      }
      p:nth-child(2):hover {
        color: #00e79a;
      }
      p:nth-child(3) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898B8D;
        flex: 0 0 16.6%;
        position: relative;
       // cursor: default;
      }
      p:nth-child(4) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898B8D;
       // cursor: pointer;
      }
      p:nth-child(5) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898B8D;
       // cursor: pointer;
      }
      p:nth-child(6) {
        font-size: 12px;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #898B8D;
        //cursor: pointer;
      }
    }
  }
  .Block_List_Bottom {
    margin-top: 20px;
    width: 1120px;
    margin: 0 auto;
  }
}
.yanca {
  color: rgba(255, 255, 255, 0.9) !important;
  cursor: text;
}
@font-face {
  font-family: "aaa";
  src: url("../../../assets/font/NotoSans-Regular.ttf");
}
.el-pagination {
  display: flex;
  justify-content: right;
  ::v-deep button {
    min-width: 24px !important;
    height: 24px !important;
    font-size: 12px;
    color:#fff !important;
    background: none !important;
    // background: #3c485c !important;
    border-radius: 4px 4px 4px 4px !important;
  }
  ::v-deep ul {
    li {
      min-width: 24px !important;
      height: 24px !important;
      background: none !important;
      //border-radius: 4px 4px 4px 4px !important;
      font-size: 12px;
      font-family: aaa;
      font-weight: 400 !important;
      color: #ffffff !important;
      line-height: 20px !important;
      margin: 0 4px !important;
      padding: 2px 8px !important;
    }
    .active {
      background: #22252E !important;
    }
    .more::before {
      line-height: 20px !important;
    }
  }
}
</style>
